export enum Icons {
  ARBITRUM = 'ARBITRUM',
  ARROWS_RIGHT_LEFT = 'ARROWS_RIGHT_LEFT',
  ARROW_DOWN = 'ARROW_DOWN',
  BASE = 'BASE',
  BOOK_OPEN_TEXT = 'BOOK_OPEN_TEXT',
  CHART_LINE = 'CHART_LINE',
  CHECK_CIRCLE = 'CHECK_CIRCLE',
  CHECK = 'CHECK',
  CHEVRON_DOWN = 'CHEVRON_DOWN',
  CHEVRON_UP = 'CHEVRON_UP',
  CHEVRON_UP_DOWN = 'CHEVRON_UP_DOWN',
  COINS = 'COINS',
  DISCORD = 'DISCORD',
  DOCUMENT_DUPLICATE = 'DOCUMENT_DUPLICATE',
  DOLLAR = 'DOLLAR',
  DROP_HALF_BOTTOM = 'DROP_HALF_BOTTOM',
  ETH = 'ETH',
  EXCLAMATION_TRIANGLE = 'EXCLAMATION_TRIANGLE',
  EXTERNAL = 'EXTERNAL',
  FLYING_SAUCER = 'FLYING_SAUCER',
  FUNNEL = 'FUNNEL',
  GAVEL = 'GAVEL',
  GHOST = 'GHOST',
  GLOBE = 'GLOBE',
  GEAR = 'GEAR',
  INFORMATION_CIRCLE = 'INFORMATION_CIRCLE',
  LIST = 'LIST',
  LOCK_CLOSED = 'LOCK_CLOSED',
  MONEY = 'MONEY',
  MOON = 'MOON',
  NO_SYMBOL = 'NO_SYMBOL',
  PHOTO = 'PHOTO',
  PENCIL_SQUARE = 'PENCIL_SQUARE',
  PLUS = 'PLUS',
  PLUS_CIRCLE = 'PLUS_CIRCLE',
  QUESTION_MARK_CIRCLE = 'QUESTION_MARK_CIRCLE',
  SEARCH = 'SEARCH',
  SHOPPING_CART = 'SHOPPING_CART',
  SPINNER_GAP = 'SPINNER_GAP',
  SUN = 'SUN',
  SWAP = 'SWAP',
  TICKET = 'TICKET',
  TWITTER = 'TWITTER',
  X_LOGO = 'X_LOGO',
  X_MARK = 'X_MARK',
  BUG = 'BUG',
}
